export default "__VITE_ASSET__CgeMB6R7__"